import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.NetSuitePurchaseOrderRequestForm.FieldsSection', {
    vendorDetailsSectionName: 'Vendor details',
    poDetailsSectionName: 'Purchase order details',
    memoSectionName: 'Memo',
    textFieldPlaceholder: 'Enter value',
    nsVendorBillingAddress: 'Billing address',
    nsVendorBillingAddressFieldPlaceholder: 'Select address',
    nsVATRegistration: 'VAT registration',
    nsTransactionNumberFieldText: 'Transaction number',
    nsReferenceFieldText: 'Reference No.',
    nsExchangeRateFieldText: 'Exchange rate',
    nsVendorFieldText: 'Vendor',
    nsVendorFieldPlaceholder: 'Select vendor',
    nsVendorReferenceFieldText: 'Reference',
    nsDueDateFieldText: 'Receive by',
    nsDueDateFieldPlaceholder: 'Select date',
    nsDateFieldText: 'Date',
    nsDateFieldPlaceholder: 'Select date',
    nsDepartmentFieldText: 'Department',
    nsDepartmentFieldPlaceholder: 'Select department',
    nsClassFieldText: 'Class',
    nsClassFieldPlaceholder: 'Select class',
    nsLocationFieldText: 'Location',
    nsLocationFieldPlaceholder: 'Select location',
    nsEmployeeFieldText: 'Employee',
    nsEmployeeFieldPlaceholder: 'Select employee',
    nsTermsFieldText: 'Terms',
    nsTermsFieldPlaceholder: 'Select terms',
    nsIncotermFieldText: 'Incoterm',
    nsIncotermFieldPlaceholder: 'Select incoterm',
    newVendor: '+ New Vendor',
});
